//  Componente stateless per visualizzazione icona svg di YouTube
import React from 'react';

const YouTubeIcon = () => {
  return (
    <svg role="graphics-symbol" aria-label="YouTube" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="youtube" transform="translate(5.000000, 9.000000)" fill='var(--social-icon)' fillRule="nonzero">
          <path d="M29.3241788,3.28921533 C28.9803285,1.9945073 27.9672263,0.974835766 26.6808942,0.62879562 C24.3493248,0 15,0 15,0 C15,0 5.65072993,0 3.31910584,0.62879562 C2.03277372,0.974890511 1.01967153,1.9945073 0.675821168,3.28921533 C0.0510766423,5.63594891 0.0510766423,10.5321898 0.0510766423,10.5321898 C0.0510766423,10.5321898 0.0510766423,15.4284307 0.675821168,17.7751642 C1.01967153,19.0698723 2.03277372,20.047062 3.31910584,20.3931022 C5.65072993,21.0218978 15,21.0218978 15,21.0218978 C15,21.0218978 24.3492701,21.0218978 26.6808942,20.3931022 C27.9672263,20.047062 28.9803285,19.0698723 29.3241788,17.7751642 C29.9489234,15.4284307 29.9489234,10.5321898 29.9489234,10.5321898 C29.9489234,10.5321898 29.9489234,5.63594891 29.3241788,3.28921533 Z M11.9422445,14.9776095 L11.9422445,6.08677007 L19.7564234,10.5322993 L11.9422445,14.9776095 Z" id="Shape" />
        </g>
      </g>
    </svg>
  );
};


export default YouTubeIcon;
